<template>
    <div class="form-group case-comment">
      <div v-if="comment(value)">
        <label for="case-comment">{{ $t('comment') }}</label>
        <pre>{{ comment(value) }}</pre>
      </div>
      <div v-else>
        {{ $t('nocomment') }}
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      comment: 'pcase/comment',
      caseById: 'pcase/byId'
    })
  }
}
</script>
<style lang="scss">
.case-comment {
    textarea {
        height: 150px;
    }
}
</style>
<i18n>
{
  "ka": {
    "comment": "კომენტარი",
    "nocomment": "კომენტარი არ არის მითითებული"
  },
  "en": {
    "comment": "Comment",
    "nocomment": "No Comment"
  }
}
</i18n>
